import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import { SidePanel, Facade } from 'Templates'

const DocumentationFacadeTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
}

export const DocumentationFacade = ({ children }) => ( 
    <div className='content'>
        <Suspense fallback={(
            <>
                <div className="page-topic">
                    <div className="page-headline">
                        <Facade
                            loading
                            animated
                            rows={4}
                            style={{ padding: 0 }} />
                    </div>
                    <div className="page-content container-filled">
                        <Facade
                            loading
                            animated
                            rows={10}
                            range={[50, 100]}
                            style={{ padding: 0 }} />
                    </div>
                </div>
                <SidePanel>
                    <Facade
                        loading
                        title={false}
                        animated
                        rows={10}
                        range={[30, 70]}
                        style={{ 
                            padding: '15px',  
                        }} />
                </SidePanel>
            </>
        )}>
            {children} 
        </Suspense>
    </div>
)

DocumentationFacade.propTypes = DocumentationFacadeTypes
